import React, {useEffect, useRef, useState} from 'react';
import './onboard-password-style.scss';
import {useTranslation} from "react-i18next";
import parse from 'html-react-parser';
import Inputmask from "inputmask";

const OnboardPassword = (props) => {
    const {t} = useTranslation();
    const {
        value,
        error,
        onChange,
        placeholder,
        showForgotPassword,
        showHint,
        onClickPasswordForgot,
        mask,
        isNotNumber,
        length
    } = props;
    const inputRef = useRef();

    const [mValue, setMValue] = useState(value != null ? value : "");
    const [mError, setMError] = useState(error);

    useEffect(() => {
        setMask();
        if (value !== undefined && value != null && value.length > 0)
            inputRef.current.value = parse(value);
    }, [])

    useEffect(() => {
        setMError(error);
    }, [error]);

    useEffect(() => {
        if (value !== undefined && value !== null)
            setMValue(value);
    }, [value])

    const handleChange = (val) => {
        if (length !== undefined) {
            if (val.target.value.toString().length > length) {
                return;
            }
        }

        if (val.target.value.toString().length <= 6) {
            setMValue(val.target.value);
            if (onChange !== undefined)
                onChange(val.target.value);
        }

        if (isNotNumber) {
            setMValue(val.target.value);
            if (onChange !== undefined)
                onChange(val.target.value);
        }

        if (error !== undefined) {
            setMError(null);
        }
    }

    const setMask = () => {
        if (mask !== undefined) {
            Inputmask({
                ...mask
            }).mask(inputRef.current);
        }
    }

    const numberInputOnWheelPreventChange = (e) => {
        e.target.blur()
        e.stopPropagation()
        setTimeout(() => {
            e.target.focus()
        }, 0)
    }

    return (
        <div className="onboard-password">
            <div className="onboard-password-inp">
                <input ref={inputRef}
                       type={isNotNumber ? 'text' : 'number'}
                       value={parse(mValue)}
                       placeholder="&nbsp;"
                       onChange={(e) => handleChange(e)}
                       onWheel={numberInputOnWheelPreventChange}
                       className={"onboard-password-password-key " + (mError ? 'onboard-password-inp-error' : '')}>
                </input>
                <div className={"onboard-password-label " +
                    (mError ? 'onboard-password-inp-error-label' : '')}>
                    {placeholder}
                </div>
                <span className="onboard-password-focus-bg"></span>
                {showForgotPassword &&
                    <div className="onboard-password-password-btn"
                         onClick={() => onClickPasswordForgot()}>{t('login.forgot_password')}</div>}
                {(!mError && showHint) && (
                    <div className="onboard-password-password-hint">{t('login.password_hint')}</div>)}
                {mError && (<div className="onboard-password-error-hint">
                    {mError.indexOf("_|") >= 0 ? (mError.substring(0, mError?.indexOf("_|"))) : mError}
                </div>)}
            </div>
        </div>
    )
};

export default OnboardPassword;
